import {Request} from './Request';
import {ChargingProfilePurposeType} from '../enums/charging.profile.purpose.enum';

export class ClearChargingProfileRequest implements Request {
    chargePointSelectList: string[];

    private filterType: string;
    private chargingProfileId: number;
    private connectorId: number;
    private chargingProfilePurpose: ChargingProfilePurposeType;
    private stackLevel: number;

    constructor(chargePointSelectList: string[], filterType?: string,
                chargingProfileId?: number, connectorId?: number, chargingProfilePurpose?: ChargingProfilePurposeType,
                stackLevel?: number) {
        this.chargePointSelectList = chargePointSelectList;
        this.filterType = filterType;
        this.chargingProfileId = chargingProfileId;
        this.connectorId = connectorId;
        this.chargingProfilePurpose = chargingProfilePurpose;
        this.stackLevel = stackLevel;
    }

    public toString = (): string => {
        return `ClearChargingProfileRequest (filterType: ${this.filterType},
        chargingProfileId: ${this.chargingProfileId}, connectorId: ${this.connectorId},
        chargingProfilePurpose: ${this.chargingProfilePurpose},
        stackLevel: ${this.stackLevel})`;
    }

    get filter_type(): string {
        return this.filterType;
    }

    set filter_type(value: string) {
        this.filterType = value;
    }

    get charging_profile_id(): number {
        return this.chargingProfileId;
    }

    set charging_profile_id(value: number) {
        this.chargingProfileId = value;
    }

    get connector_id(): number {
        return this.connectorId;
    }

    set connector_id(value: number) {
        this.connectorId = value;
    }

    get charging_profile_purpose(): ChargingProfilePurposeType {
        return this.chargingProfilePurpose;
    }

    set charging_profile_purpose(value: ChargingProfilePurposeType) {
        this.chargingProfilePurpose = value;
    }

    get stack_level(): number {
        return this.stackLevel;
    }

    set stack_level(value: number) {
        this.stackLevel = value;
    }
}

/*
chargePointSelectList: JSON;EVB-P20261797;-
chargePointSelectList: 1
listVersion: 4
updateType: FULL
addUpdateList: 1
deleteList: 1
sendEmptyListWhenFull: on



chargePointSelectList: JSON;EVB-P20261797;-
chargePointSelectList: 1
listVersion: 4
updateType: DIFFERENTIAL
addUpdateList: 04B0267AE05C87
addUpdateList: 1
deleteList: 123456789
deleteList: 1
sendEmptyListWhenFull: on
csrf: 7f448777-54a3-4050-8ec1-9c696b0d47ef


 */
